<template>
  <div>
    <div class="banner">
      <img :src="banner" v-if="clientWidth > 768" />
      <img :src="banner_m" v-else />
      <!-- <div class="banner_title">{{ banner_title }}</div> -->
    </div>
    <div class="tabs">
      <div class="content">
        <div :class="active === index ? 'tab tab_active' : 'tab'" v-for="(item, index) in tabs" :key="item.id"
          @click="tabChange(item, index)">
          <el-image class="icon" fit="contain" :src="active === index ? item.icon_active : item.icon"></el-image>
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="module">
      <div class="content">
        <div class="cards" v-if="clientWidth > 768">
          <div class="card" v-for="(item, index) in cards" :key="index">
            <div class="card_bg">
              <img :src="Res_Url + '/exhibition/new_block.png'">
            </div>

            <div :id="'title' + index" class="title" v-html="item.title"></div>
            <div class="info">
              <div class="introduction" v-html="item.introduction.split('/n').join('<br />')"></div>
              <div class="info_btns ffff"  v-if="item.pdf_url || item.question ">
               
                <div class="info_btn download" v-if="item.pdf_url" @click="download(item)"
                  v-ga="{ event: 'trk', ec: 'products', ea: 'pdf', el: 'pdf' }">
                  PDF 下载 <el-image :src="imgs.download"></el-image>
                </div>
                <div class="info_btn exam" v-if="item.question" @click="toExam(item)"
                  v-ga="{ event: 'trk', ec: 'products', ea: 'quiz', el: 'quiz' }">
                  小问答 <el-image :src="imgs.exam"></el-image>
                </div>
                <!-- <div :class="item.audio.play ? 'playing' : 'pause'" class="info_btn" v-if="item.audio"
                  @click="playAudio(index, item.audio.play, item.audio.time)"
                  v-ga="{ event: 'trk', ec: 'products', ea: 'products', el: 'audio' }">
                  语音导览 <el-image :src="item.audio.play ? imgs.play : imgs.pause"></el-image>
                </div> -->
              </div>
              <el-collapse-transition>
                <div class="data" v-if="activeShow === index">
                  <div v-if="item.data.length == 1">
                    <img v-if="item.data[0].type === 'image'" :src="Res_Url2026 + '/exhibition/' + item.data[0].content"
                      @click="imgPreview(item.data[0])" />
                    <div class="video" v-if="item.data[0].type === 'video'">
                      <video ref="video" :src="item.data[0].content"
                        :poster="item.data[0].poster != undefined ? Res_Url2026 + '/exhibition/' + item.data[0].poster : Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>
                      <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(item.data[0])" />

                    </div>
                  </div>
                  <div v-else>
                    <swiper :options="swiperOption" :key="'pc-swiper-' + index" ref="mySwiper" class="data_swiper_box">
                      <div class="swiper-button-prev s-prev" slot="button-prev"></div>
                      <div class="swiper-button-next s-next" slot="button-next"></div>
                      <swiper-slide class="data_swiper" v-for="(sub, subIndex) in item.data" :key="subIndex">
                        <div class="unit">
                          <img v-if="sub.type === 'image'" :src="Res_Url2026 + '/exhibition/' + sub.content" alt=""
                            @click="imgPreview(sub)" />
                          <div class="video" v-if="sub.type === 'video'">
                            <video ref="video" :src="sub.content"
                              :poster="sub.poster != undefined ? Res_Url2026 + '/exhibition/' + sub.poster : Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>
                            <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(sub)" />
                          </div>
                          <div class="title">{{ sub.title }}</div>
                        </div>
                      </swiper-slide>
                    </swiper>
                    <div class="pages" v-show="item.data.length > 0">
                      <img :src="Res_Url + '/exhibition/line_left.png'" alt="" />
                      {{ pageIndex }}/{{ item.data.length }}
                      <img :src="Res_Url + '/exhibition/line_right.png'" alt="" />
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </div>
            <div :style="item.data.length === 0 ? 'opacity: 0' : 'opacity: 1'" class="btn" @click="isShow(item, index)"
              v-ga="{ event: 'trk', ec: 'products', ea: 'showmore', el: 'fold' }">
              {{ activeShow === index ? "收起" : "展开" }}
              <el-image :class="activeShow === index ? 'arrow_up' : 'arrow_down'" :src="imgs.arrow_up"></el-image>
            </div>
          </div>
        </div>
        <div class="cards" v-else>
          <div class="card_m" v-for="(item, index) in cards" :key="index">
            <div class="head">
              <div :id="'title' + index" class="title" v-html="item.title"></div>
              <!-- :style="item.data.length === 0 ? 'opacity: 0' : 'opacity: 1'" -->
              <div class="btn" @click="isShow(item, index)">
                {{ activeShow === index ? "收起" : "展开" }}
                <el-image :class="activeShow === index ? 'arrow_up' : 'arrow_down'" :src="imgs.arrow_up"></el-image>
              </div>
            </div>
            <div :class="activeShow === index
              ? 'introduction'
              : 'introduction introduction_low'
              " v-html="item.introduction.split('/n').join('<br />')"></div>
            <div class="info_btns" v-if="item.pdf_url || item.question || item.audio">
              <div class="info_btn download" v-if="item.pdf_url" @click="download(item)">
                PDF 下载 <el-image :src="imgs.download"></el-image>
              </div>
              <div class="info_btn exam" v-if="item.question" @click="toExam(item)">
                小问答 <el-image :src="imgs.exam"></el-image>
              </div>
              <!-- <div :class="item.audio.play ? 'playing' : 'pause'" class="info_btn" v-if="item.audio"
                @click="playAudio(index, item.audio.play, item.audio.time)"
                v-ga="{ event: 'trk', ec: 'products', ea: 'products', el: 'audio' }">
                语音导览 <el-image :src="item.audio.play ? imgs.play : imgs.pause"></el-image>
              </div> -->
            </div>
            <el-collapse-transition>
              <div class="data" v-if="activeShow === index">
                <div v-if="item.data.length == 1">
                  <img v-if="item.data[0].type === 'image'" :src="Res_Url2026 + '/exhibition/' + item.data[0].content"
                    @click="imgPreview(item.data[0])" />
                  <div class="video" v-if="item.data[0].type === 'video'">
                    <video ref="video" :src="item.data[0].content"
                      :poster="item.data[0].poster != undefined ? Res_Url2026 + '/exhibition/' + item.data[0].poster : Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>

                    <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(item.data[0])" />
                  </div>
                </div>
                <div v-else>
                  <swiper :options="swiperOption" :key="'m-swiper-' + index" ref="mySwiper" class="data_swiper_box">
                    <div class="swiper-button-prev s-prev" slot="button-prev"></div>
                    <div class="swiper-button-next s-next" slot="button-next"></div>
                    <swiper-slide class="data_swiper" v-for="(sub, subIndex) in item.data" :key="subIndex">
                      <div class="unit">
                        <img v-if="sub.type === 'image'" :src="Res_Url2026 + '/exhibition/' + sub.content" alt=""
                          @click="imgPreview(sub)" />
                        <div class="video" v-if="sub.type === 'video'">
                          <video ref="video" :src="sub.content"
                            :poster="sub.poster != undefined ? Res_Url2026 + '/exhibition/' + sub.poster : Res_Url2026 + '/exhibition/新品展示所有视频的封面.png'"></video>
                          <img :src="Res_Url + '/exhibition/play.png'" alt="" @click="videoPlay(sub)" />
                        </div>
                        <div class="title">{{ sub.title }}</div>
                      </div>
                    </swiper-slide>
                  </swiper>
                  <div class="pages" v-show="item.data.length > 0">
                    <img :src="Res_Url + '/exhibition/line_left.png'" alt="" />
                    {{ pageIndex }}/{{ item.data.length }}
                    <img :src="Res_Url + '/exhibition/line_right.png'" alt="" />
                  </div>
                </div>
              </div>
            </el-collapse-transition>
          </div>
        </div>
      </div>
    </div>

    <transition name="el-fade-in">
      <div v-show="video_box_show" class="video-box">
        <div class="content">
          <div class="video">
            <iframe id="cciframe_503DC188EBBE36BEF3342D97BB1D6DF8" :src="currentVideo" v-if="currentVideo != ''"
              frameborder="0" allowfullscreen></iframe>
            <!-- <i class="el-icon-circle-close" @click="boxClose"></i> -->
            <span class="question-close" @click="boxClose">×</span>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in">
      <div v-show="img_box_show" class="img_box">
        <div class="content content-img">
          <div class="img">
            <img :src="currentImg ? Res_Url2026 + '/exhibition/' + currentImg : ''" alt="" />
            <!-- <i class="el-icon-circle-close" @click="boxClose"></i> -->
            <span class="question-close" @click="boxClose">×</span>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-fade-in">
      <div v-show="question_box_show" class="question_box">
        <div class="question">
          <div class="head">
            新品展示小问答
            <!-- <i class="el-icon-circle-close" @click="boxClose"></i> -->
            <span class="question-close" @click="boxClose">×</span>
          </div>
          <div class="container">
            <div class="title">
              <img class="icon" :src="Res_Url + '/exhibition/question_title_icon.png'" alt="" />{{
                question.title }}
            </div>
            <el-radio-group v-if="question.title.indexOf('多选') === -1" v-model="currentSelect">
              <el-radio v-for="(item, index) in question.select" :key="item" :label="index">{{ item }}</el-radio>
            </el-radio-group>
            <el-checkbox-group v-else v-model="currentSelect">
              <el-checkbox v-for="(item, index) in question.select" :key="index" :value="item" :label="index">{{ item
              }}</el-checkbox>
            </el-checkbox-group>
            <div class="btns">
              <div class="cancel" @click="boxClose">返回新品展示</div>
              <div class="confirm" @click="confirm">提交</div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <Rdialog :articleCode="articleCode" :isRegister="isRegister" :isEmail="isEmail" @handleClose="handleClose"
      @handleEmail="handleEmail" :isIntegral="isIntegral" :integralText="integralText"></Rdialog>
    <Qdialog :isSuccess="isSuccess" :isOk="isOk" :isError="isError" @handleClose="handleClose"
      @handleReset="handleReset" text="新品展示"></Qdialog>
    <!-- 音频 -->
    <div class="audioBox" v-if="false">
      <audio controls ref="audioEle" @timeupdate="updateProgress">
        <source :src="audios[active]">
      </audio>
    </div>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);
import Rdialog from "@/components/rdialog/index.vue";
import Qdialog from "@/components/qdialog/index.vue";
import {
  AddPoints,
  SubmitNewProduct,
  SubmitNewProductPost,
  GetUserLogs,
} from "../../api/index.js";
import exhibitionData from "@/assets/json/exhibition";
import { Res_Url, Res_Url2026 } from "@/utils/ApiToken.js";
export default {
  data() {
    const that = this;
    return {
      Res_Url: Res_Url,
      Res_Url2026: Res_Url2026,
      exhibitionData,
      banner_title: "工业自动化",
      // 静态资源图片
      imgs: {
        arrow_up:
          "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/arrow_up.png",
        arrow_down:
          "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/arrow_down.png",
        download:
          "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/download.png",
        exam: "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/exam.png",
        pause: "https://staticdn.ht-s.cn/se/ciif/2024/common/audio-pause.png",
        play: "https://staticdn.ht-s.cn/se/ciif/2024/common/audio-playing.png"
      },
      banner: Res_Url2026 + "/exhibition/banner.png",
      banner_m: Res_Url2026 + "/exhibition/banner_m.png",
      tabs: [
        {
          id: 1,
          icon: "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/tab_icon2.png",
          icon_active:
            "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/tab_icon2_active.png",
          name: "工业自动化",
        },
        {
          id: 2,
          icon: "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/tab_icon4.png",
          icon_active:
            "https://staticdn.ht-s.cn/se/ciif/2024/exhibition/tab_icon4_active.png",
          name: "能源管理",
        },
      ],
      active: 0,
      video_box_show: false,
      currentVideo: "",
      img_box_show: false,
      currentImg: "",
      pageIndex: 1,
      swiperOption: {
        direction: "horizontal",
        initialSlide: 0,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: ".data_swiper_box .swiper-button-next",
          prevEl: ".data_swiper_box .swiper-button-prev",
        },
        on: {
          init: (swiper) => {
            that.pageIndex = swiper.activeIndex + 1;
          },
          slideChange: (swiper) => {
            that.pageIndex = swiper.activeIndex + 1;
          },
        },
      },
      isRegister: false,
      isEmail: false,
      question_box_show: false,
      question: {
        title: "如下哪个不是施耐德电气 EcoStruxure™ 开放自动化平台的正确表述？",
        select: [
          "A.促进 100% 的工程效率",
          "B.实现 100% 的运营效率",
          "C.应对 100% 的未来挑战",
          "D.完成 100% 的工作任务",
        ],
        answer: 0,
      },
      currentSelect: -1,
      isSuccess: false,
      isOk: false,
      isError: false,
      articleCode: "",
      activeShow: 0,
      cards: [],
      questionType: "radio",
      isIntegral: false,
      integralText: "",
      // 语音导览
      audioIndex: 0,
      playing: false,
      // audios: [
      //   'https://events.schneider-electric.cn/ciif2024/2024/exhibition/gyzdh.mp3',
      //   'https://events.schneider-electric.cn/ciif2024/2024/exhibition/nygl.mp3'
      // ]
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    Rdialog,
    Qdialog,
  },
  created() {
    this.$store.commit("load", true);

    this.exhibitionDataCopy = JSON.parse(JSON.stringify(this.exhibitionData));
    // 切换到对应tab
    this.active = this.$route.query.tab == "true" ? 1 : 0;
    this.banner_title = this.tabs[this.active].name;
    this.cards =
      this.active == 0
        ? this.exhibitionDataCopy.industrial
        : this.exhibitionDataCopy.energy;
    // // 滚动到指定区域
    if (this.$route.query.title) {
      let i = this.cards.findIndex(
        (item) => item.title === this.$route.query.title
      );
      let card = JSON.parse(JSON.stringify(this.cards[i]));
      this.cards.splice(i, 1);
      this.cards.unshift(card);
    }
  },
  mounted() {
    GetUserLogs({
      visitName: "页面访问-新品展示",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 11058
    });
  },
  methods: {
    // 语音导览,播放
    playAudio(index, status, time) {
      var that = this;
      let audioIndex = this.audioIndex;
      const audio = this.$refs.audioEle;
      console.log(index, status, time);
      if (status) {
        audio.pause();
        this.playing = false;
        setTimeout(function () {
          that.cards[index].audio.play = false;
        }, 300);
      } else {
        for (var i = 0; i < this.cards.length; i++) {
          if (this.cards[i].audio) {
            this.cards[i].audio.play = false;
          }
        }
        let [startTime, endTime] = this.parseTimeRangeToSeconds(time);
        audio.currentTime = startTime;
        audio.play();
        this.cards[index].audio.play = true;
        this.playing = true;

      }
    },
    updateProgress(event) {
      const audio = event.target;
      // console.log(audio.currentTime);
      for (var i = 0; i < this.cards.length; i++) {
        if (this.cards[i].audio) {
          let [startTime, endTime] = this.parseTimeRangeToSeconds(this.cards[i].audio.time);
          this.cards[i].audio.play = false;
          if (audio.currentTime >= startTime && audio.currentTime <= endTime && audio.currentTime != 0) {
            this.cards[i].audio.play = true;
            this.audioIndex = i;
          }
        }
      }
    },
    parseTimeRangeToSeconds(timeRange) {
      // 使用'-'分割时间范围字符串得到起始时间和结束时间
      const times = timeRange.split('-');
      const startTime = times[0].split(':').reduce((acc, cur, index) => {
        // 第一部分是分钟，第二部分是秒
        return acc + parseInt(cur) * (index === 0 ? 60 : 1);
      }, 0);

      const endTime = times[1].split(':').reduce((acc, cur, index) => {
        // 第一部分是分钟，第二部分是秒
        return acc + parseInt(cur) * (index === 0 ? 60 : 1);
      }, 0);

      return [startTime, endTime];
    },
    videoPlay(item) {
      const obj = { event: "trk", ec: "products", ea: "products", el: "video" };
      dataLayer.push(JSON.parse(JSON.stringify(obj)))
      this.currentVideo = item.content;
      this.video_box_show = true;
    },
    imgPreview(item) {
      (this.currentImg = item.content), (this.img_box_show = true);
    },
    boxClose() {
      const obj = {
        event: "trk",
        ec: "popup",
        ea: "close",
        el: "close",
      };
      dataLayer.push(JSON.parse(JSON.stringify(obj)))
      this.video_box_show = false;
      this.img_box_show = false;
      this.question_box_show = false;
      this.currentVideo = "";
      this.currentImg = "";
    },
    toExam(item) {
      if (this.$store.state.islogin) {
        console.log(item.code)

        this.articleCode = item.code;
        if (item.question.title.indexOf("多选") === -1) {
          console.log(1)
          this.questionType = "radio";
          this.currentSelect = -1;
        } else {

          this.currentSelect = [];
          this.questionType = "checkbox";
        }
        SubmitNewProduct(item.code).then((res) => {
          if (res.Status === 1) {
            this.question = JSON.parse(JSON.stringify(item.question));
            this.question_box_show = true;
          } else {
            this.isSuccess = true;
          }
        });
      } else {
        this.isRegister = true;
      }
    },
    isShow(item, index) {
      if (this.activeShow != index) {
        this.pageIndex = 1;
        this.activeShow = index;
      } else {
        this.activeShow = -1;
      }
    },
    confirm() {
      if (this.currentSelect !== -1 && this.currentSelect.length !== 0) {
        this.$store.commit("load", true);
        let answer = "";
        if (typeof this.currentSelect === "number") {
          switch (this.currentSelect) {
            case 0:
              answer = "A";
              break;
            case 1:
              answer = "B";
              break;
            case 2:
              answer = "C";
              break;
            case 3:
              answer = "D";
              break;
            case 4:
              answer = "E";
              break;
            case 5:
              answer = "F";
              break;
            case 6:
              answer = "G";
              break;
            case 7:
              answer = "H";
              break;
          }
        } else {
          this.currentSelect = this.currentSelect.join(",");
          this.currentSelect = this.currentSelect.replace("0", "A");
          this.currentSelect = this.currentSelect.replace("1", "B");
          this.currentSelect = this.currentSelect.replace("2", "C");
          this.currentSelect = this.currentSelect.replace("3", "D");
          this.currentSelect = this.currentSelect.replace("4", "E");
          this.currentSelect = this.currentSelect.replace("5", "F");
          this.currentSelect = this.currentSelect.replace("6", "G");
          this.currentSelect = this.currentSelect.replace("7", "H");
          answer = this.currentSelect;
        }

        this.question_box_show = false;
        SubmitNewProductPost(
          {
            answer: answer,
            answerCode: this.articleCode,
          },
          this.$route.query.track
        ).then((res) => {
          setTimeout(() => {
            this.$store.commit("load", false);
            if (res.Status === 1) {
              this.isError = true;
            } else if (res.Status === 2) {
              this.isOk = true;
            }
          }, 500);
        });
      } else {
        this.$toast("请选择一个选项！");
      }
    },
    handleClose() {
      this.isSuccess = false;
      this.isOk = false;
      this.isError = false;
      this.isEmail = false;
      this.isRegister = false;
      this.isIntegral = false
    },
    handleReset() {
      this.isError = false;
      if (this.questionType === "radio") {
        this.currentSelect = -1;
      } else {
        this.currentSelect = [];
      }
      this.question_box_show = true;
    },
    download(item) {
      if (this.$store.state.islogin) {
        this.articleCode = item.code;
        this.isEmail = true;
      } else {
        this.isRegister = true;
      }
    },
    handleEmail(e) {
      AddPoints({
        visitType: 24,
        track: this.$route.query.track ? this.$route.query.track : "",
        name: this.articleCode,
        email: e,
      }).then((res) => {
        this.isEmail = false;
        this.isIntegral = true;
        if (res.Data === "1") {
          this.integralText = res.Message;
        } else {
          this.integralText = "恭喜您，下载成功";
        }
      });
    },
    tabChange(item, index) {
      var obj;
      if (index == 0) {
        obj = { event: "trk", ec: "tab", ea: "iac", el: 'iac' };
      } else {
        obj = { event: "trk", ec: "tab", ea: "em", el: 'em' };
      }

      var ga_Code = JSON.parse(JSON.stringify(obj));
      dataLayer.push(ga_Code);
      this.cards =
        index == 0
          ? this.exhibitionDataCopy.industrial
          : this.exhibitionDataCopy.energy;
      // 暂停音频播放
      if (this.playing) {
        const audio = this.$refs.audioEle;
        audio.pause();
        this.cards[this.audioIndex].audio.play = false;
        this.playing = false;
      }
      this.active = index;
      this.banner_title = item.name;

      this.$nextTick(() => {
        this.$refs.audioEle.load();
        // 如果需要，可以在这里自动开始播放新音频
        // this.$refs.audioEle.play().catch(err => console.error('Failed to play the new audio:', err));
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>